import { useEffect } from "react";

const upsertMeta = (selector, create, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const meta = (name) => () => {
  const el = document.createElement("meta");
  el.setAttribute("name", name);
  return el;
};

const prop = (property) => () => {
  const el = document.createElement("meta");
  el.setAttribute("property", property);
  return el;
};

export function useSeo({ title, description, path, image, noindex = false }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('meta[property="og:title"]', prop("og:title"), title);
      upsertMeta('meta[name="twitter:title"]', meta("twitter:title"), title);
    }
    if (image) {
      const abs = image.startsWith("http") ? image : `${process.env.REACT_APP_BACKEND_URL}${image}`;
      upsertMeta('meta[property="og:image"]', prop("og:image"), abs);
      upsertMeta('meta[name="twitter:image"]', meta("twitter:image"), abs);
    }
    if (description) {
      upsertMeta('meta[name="description"]', meta("description"), description);
      upsertMeta('meta[property="og:description"]', prop("og:description"), description);
      upsertMeta('meta[name="twitter:description"]', meta("twitter:description"), description);
    }
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    upsertMeta('meta[property="og:url"]', prop("og:url"), url);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", url);
    let robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, noindex]);
}
